import { Briefcase, Bell, Wrench, DollarSign, FileText, ShoppingCart, History, List, Shield, Calculator, Bot, ClipboardList } from 'lucide-react';
import TabHub from '@/components/shared/TabHub';
import PortfolioTracker from '@/components/portfolio/PortfolioTracker';
import PaperTrades from '@/components/portfolio/PaperTrades';
import AlertBuilder from '@/components/alerts/AlertBuilder';
import PriceAlerts from '@/components/portfolio/PriceAlerts';
import OpenOrders from '@/components/trading/OpenOrders';
import TradeHistory from '@/components/trading/TradeHistory';
import OrderTicket from '@/components/trading/OrderTicket';
import PositionSizer from '@/components/trading/PositionSizer';
import WatchlistManager from '@/components/portfolio/WatchlistManager';
import RiskDashboard from '@/components/portfolio/RiskDashboard';
import AutoTradeRules from '@/components/trading/AutoTradeRules';
import TaxReporting from '@/components/portfolio/TaxReporting';

export default function PortfolioHub() {
  return (
    <TabHub
      title="Portfolio & Trading"
      subtitle="Live broker positions, order execution, risk management, watchlists, and alerts"
      icon={Briefcase}
      accentColor="#3b82f6"
      defaultTab="portfolio"
      tabs={[
        { id: 'portfolio', label: 'Portfolio', icon: Briefcase, component: <PortfolioTracker /> },
        { id: 'order-ticket', label: 'Order Ticket', icon: ShoppingCart, badge: 'LIVE', component: <OrderTicket /> },
        { id: 'open-orders', label: 'Open Orders', icon: ClipboardList, component: <OpenOrders /> },
        { id: 'trade-history', label: 'Trade History', icon: History, component: <TradeHistory /> },
        { id: 'position-sizer', label: 'Position Sizer', icon: Calculator, component: <PositionSizer /> },
        { id: 'watchlists', label: 'Watchlists', icon: List, component: <WatchlistManager /> },
        { id: 'risk', label: 'Risk Dashboard', icon: Shield, component: <RiskDashboard /> },
        { id: 'price-alerts', label: 'Alerts', icon: Bell, component: <PriceAlerts marketType="crypto" /> },
        { id: 'auto-trade', label: 'Auto Trading', icon: Bot, badge: 'NEW', component: <AutoTradeRules /> },
        { id: 'tax', label: 'Tax Report', icon: DollarSign, component: <TaxReporting /> },
        { id: 'paper-trades', label: 'Paper Trades', icon: FileText, badge: 'SIM', component: <PaperTrades /> },
        { id: 'builder', label: 'Alert Builder', icon: Wrench, component: <AlertBuilder theme="dark" /> },
      ]}
    />
  );
}
